export const protiZaplaceniTuzemskaMenaSelect = [
    {
        value: 'CZK',
        labelcz: 'Česká koruna',
        labelen: 'Czech Koruna'
    }
];

export const protiZaplaceniDltMenaSelect = [
    {
        value: 'EUR',
        labelcz: 'Euro',
        labelen: 'Euro'
    }
];

export const protiZaplaceniMenaSelect = [
    {
        value: 'EUR',
        labelcz: 'Euro',
        labelen: 'Euro'
    },
    {
        value: 'GBP',
        labelcz: 'Britská libra',
        labelen: 'Pound Sterling'
    },
    {
        value: 'USD',
        labelcz: 'Americký dolar',
        labelen: 'US Dollar'
    }
];
